function _typeof(obj) {
    '@babel/helpers - typeof';
    return _typeof = 'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator ? function (obj) {
        return typeof obj;
    } : function (obj) {
        return obj && 'function' == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? 'symbol' : typeof obj;
    }, _typeof(obj);
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError('Cannot call a class as a function');
    }
}
function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ('value' in descriptor)
            descriptor.writable = true;
        Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps)
        _defineProperties(Constructor.prototype, protoProps);
    if (staticProps)
        _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, 'prototype', { writable: false });
    return Constructor;
}
function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, 'string');
    return _typeof(key) === 'symbol' ? key : String(key);
}
function _toPrimitive(input, hint) {
    if (_typeof(input) !== 'object' || input === null)
        return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || 'default');
        if (_typeof(res) !== 'object')
            return res;
        throw new TypeError('@@toPrimitive must return a primitive value.');
    }
    return (hint === 'string' ? String : Number)(input);
}
import utils from './utils';
import DanmakuAuxiliaryTemplate from '../../template/danmakuAuxiliary.art';
import DanmakuList from './danmakuList/danmakuList';
import AdvancedDanmakuEditor from './advancedDanmakuEditor/advancedDanmakuEditor';
var DanmakuAuxiliary = function () {
    function DanmakuAuxiliary(player, el) {
        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        _classCallCheck(this, DanmakuAuxiliary);
        this.options = options;
        this.player = player;
        this.el = el;
        this.template = this.player.template;
        this.mount();
    }
    _createClass(DanmakuAuxiliary, [
        {
            key: 'mount',
            value: function mount() {
                this.el.classList.add('mfunsPlayer-danmaku-auxiliary');
                this.el.innerHTML = DanmakuAuxiliaryTemplate();
                var $ = this.el.querySelector.bind(this.el);
                this.template.danmaku_list_wrapper = $('.mfunsPlayer-danmaku-list-wrapper');
                this.template.ade_wrapper = $('.mfunsPlayer-ade-wrapper');
                this.template.ade_btn = $('.mfunsPlayer-ade-button');
                this.template.ade_exit_btn = $('.mfunsPlayer-ade-exit-button');
                this.danmakuList = new DanmakuList(this.player, this.template.danmaku_list_wrapper, this.options);
                this.advancedDanmakuEditor = new AdvancedDanmakuEditor(this.player, this.template.ade_wrapper, this.options);
                this.template.ade_btn.addEventListener('click', this.showADE.bind(this));
                this.template.ade_exit_btn.addEventListener('click', this.hideADE.bind(this));
            }
        },
        {
            key: 'showADE',
            value: function showADE() {
                this.template.danmaku_list_wrapper.style['display'] = 'none';
                this.template.ade_wrapper.style['display'] = '';
            }
        },
        {
            key: 'hideADE',
            value: function hideADE() {
                this.template.danmaku_list_wrapper.style['display'] = '';
                this.template.ade_wrapper.style['display'] = 'none';
            }
        }
    ]);
    return DanmakuAuxiliary;
}();
export default DanmakuAuxiliary;